import { defineMessages } from "react-intl";

export const messages = defineMessages({
  appPermissions: {
    id: "xNfh4L",
    defaultMessage: "App permissions",
    description: "app permissions tooltip header",
  },
  noPermissions: {
    id: "lSd5Zo",
    defaultMessage: "None",
    description: "app permissions label",
  },
});
